module.exports = __webpack_public_path__ + "static/img/hero5_info.307868d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/hero5_info.png
// module id = Skcy
// module chunks = 1